import { render, staticRenderFns } from "./SeguroEntradasComponent.vue?vue&type=template&id=4c5189de"
import script from "./SeguroEntradasComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SeguroEntradasComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports